import { QueryStringFilter, QueryStringParam } from './types';

export const budgetFilterMaximum = 1000000;

type BudgetQueryStringFilter = QueryStringFilter<GQL.ITrackSearchBudgetFilter | undefined>;

export const BudgetFilter: BudgetQueryStringFilter = {
  serialize: (budget) => {
    if (budget) {
      if (budget.minimum) {
        if (budget.maximum) {
          return `${budget.minimum}-${budget.maximum}`;
        } else {
          return `>${budget.minimum}`;
        }
      } else if (budget.maximum) {
        return `<${budget.maximum}`;
      }
    }

    return '';
  },
  unserialize: (query) => {
    if (QueryStringParam.Budget in query) {
      const budget = query[QueryStringParam.Budget];
      const parts = budget.match(/^([<,>]?)(\d*)-?(\d*)$/);
      if (parts != null) {
        const [, symbol, first, second] = parts;
        const firstNumber = parseInt(first, 10);
        const secondNumber = parseInt(second, 10);
        switch (symbol) {
          case '<':
            return {
              minimum: 0,
              maximum: firstNumber,
            };
          case '>':
            return {
              minimum: firstNumber,
              maximum: budgetFilterMaximum,
            };
          default:
            return {
              minimum: firstNumber,
              maximum: secondNumber || firstNumber,
            };
        }
      }
    }

    return;
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/queryString/budgetFilter.ts